import {
  Activity, AlertTriangle, Ban, BarChart3, BookMarked, Bookmark, Bot, BrainCircuit,
  ChartSpline, Columns3, DollarSign, FileSpreadsheet, FileText, FlaskConical, FolderTree, Headset, HeartPulse,
  Image as ImageIcon, LayoutList, LineChart, ListChecks, Logs, MessageCircleQuestion,
  MessageSquare, MessageSquareWarning, Monitor, PackagePlus, PackageSearch, Percent,
  Phone, PlusCircle, Search, Settings, ShieldCheck, ShoppingBasket, ShoppingCart,
  Scale, Sparkles, Store, Ticket, TrendingUp, Trophy, Truck, Undo2, Users, UsersRound, Wallet,
} from 'lucide-react';

/**
 * Ícone de cada tela, para o atalho da navbar ficar reconhecível de relance.
 * Segue as mesmas escolhas da sidebar; o que não estiver aqui cai na bandeira.
 */
const ICONES = {
  '/dashboard': ChartSpline,
  '/dre': BarChart3,
  '/dre/detalhado': BarChart3,
  '/dre/custos': Wallet,
  '/dre/categorias': FolderTree,
  '/dre/furo-estoque': AlertTriangle,
  '/desempenho': Trophy,
  '/comparador-precos': DollarSign,
  '/precificacao-inteligente': TrendingUp,
  '/compra-inteligente': BrainCircuit,

  '/vendas': ShoppingCart,
  '/vendas_vendedor': Store,
  '/venda_manual': ShoppingBasket,
  '/orcamentos': FileSpreadsheet,
  '/notas_fiscais': FileText,

  '/despacho': ListChecks,
  '/pendencias-vendas': AlertTriangle,
  '/acompanhamento_pedidos': LineChart,
  '/compatibilidade-catalogo': ShieldCheck,
  '/processador/monitoramento': LineChart,

  '/devolucoes': Undo2,
  '/reclamacoes': MessageSquareWarning,
  '/anuncios/denuncias': Ban,

  '/listas-compras/dashboard': ShoppingCart,
  '/listas-compras/kanban': Columns3,
  '/cotacoes_automaticas': PlusCircle,
  '/cotacoes': FileText,
  '/cobertura-furos': PackageSearch,
  '/divergencias-preco': Scale,

  '/produtos': LayoutList,
  '/gestao_estoque': PackageSearch,
  '/revisao-estoque': ShieldCheck,
  '/entrada-estoque': PackagePlus,
  '/promocoes': Percent,
  '/concorrencia': BarChart3,
  '/banco-imagens': ImageIcon,
  '/imagens-bloqueadas': Ban,
  '/migracao-imagens': ImageIcon,
  '/saude-anuncios': HeartPulse,
  '/metricas-anuncios': BarChart3,

  '/clientes': Users,
  '/crm': Headset,
  '/perguntas': MessageCircleQuestion,
  '/mensageria': MessageSquare,
  '/prospeccao': Search,
  '/assistente-vendas': Sparkles,
  '/chat-ia': Bot,
  '/bot-custos-ia': DollarSign,
  '/bot-teste-ab': FlaskConical,
  '/discador': Phone,

  '/melhor-envio': Truck,
  '/tickets': Ticket,
  '/wiki': BookMarked,
  '/guias': BookMarked,

  '/exportar_produtos': FileSpreadsheet,
  '/exportar_clientes': FileSpreadsheet,
  '/exportar_vendas': FileSpreadsheet,
  '/exportar_conversas': MessageSquare,

  '/servidor': Monitor,
  '/configuracoes': Settings,
  '/usuarios': UsersRound,
  '/permissoes': ShieldCheck,
  '/log-acessos': Activity,
  '/logs': Logs,
  '/logs_produtos': Logs,
};

export const iconeDaPagina = (pagina) => ICONES[pagina] || Bookmark;
